<template>
  <v-main v-resize="onResize" ref="content" class="pt-0">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="0" class="mt-2">
            <v-tabs v-model="selectedTab" height="35" slider-size="3" :background-color="color(3)" class="rounded-0">
              <v-tab>{{ $t('sod.ttl.dashboard') }}</v-tab>
              <v-tab>{{ $t('sod.ttl.define.matrix') }}</v-tab>
              <v-tab>{{ $t('sod.ttl.define.ra.auth') }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="selectedTab">
              <v-tab-item transition="false" reverse-transition="false">
                <dashboard :height="height" />
              </v-tab-item>
              <v-tab-item transition="false" reverse-transition="false">
                <define-sod-matrix :height="height" />
              </v-tab-item>
              <v-tab-item transition="false" reverse-transition="false">
                <define-ra-auth :height="height" />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Dashboard from './Dashboard.vue';
import DefineSodMatrix from './DefineSodMatrix.vue';
import DefineRaAuth from './DefineRaAuth.vue';

export default {
  components: {
    Dashboard,
    DefineSodMatrix,
    DefineRaAuth,
  },
  data() {
    return {
      selectedTab: null,
      height: 0,
      lowerCardHeight: 0,
    };
  },
  methods: {
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
    onResize() {
      this.height = window.innerHeight - 130;
    },
  },
};
</script>
